import {useEffect } from 'react';

const listener = (key, onEvent) => {
    const listener = event => {
        if (event.code === key) {
              event.preventDefault();
              onEvent();
        }
    };
    document.addEventListener("keydown", listener);

    return () => {
        document.removeEventListener("keydown", listener);
    };
  };

export const useOnEnter = (onEvent) => {

    useEffect(() => {
        return listener('Enter', onEvent);
      }, []);
};

export const useOnЕscape = (onEvent) => {

    useEffect(() => {
        return listener('Escape', onEvent);
      }, []);
};
